import { Component, Input } from '@angular/core';
import { EmojisRubric } from '@tekman/onmat/service/onmat';

@Component({
  selector: 'skeleton-loader',
  templateUrl: './skeleton-loader.component.html',
  styleUrls: ['./skeleton-loader.component.scss'],
})
export class SkeletonLoaderComponent {
  @Input() type: string;
  @Input() lines: string[];
  readonly rubricIcons: EmojisRubric[] = [EmojisRubric.BAD, EmojisRubric.REGULAR, EmojisRubric.GOOD, EmojisRubric.EXCELLENT];
}
